export default __webpack_public_path__ + "static/media/icn_biostrap.25e69c4f.svg";